import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink2';
import { Observable } from 'rxjs';
import * as moment from "moment";

@Component({
  selector: 'app-util-cash-document-view-line',
  templateUrl: './cash-document-view-line.component.html',
  styleUrls: ['./cash-document-view-line.component.css']
})
export class CashDocumentViewLineComponent implements OnInit, OnDestroy {
  @Input() cashDoc$: Observable<any>;
  @Input() localState: any;
  protected subs = new SubSink();

  defaultColDef = {
    filter: 'agTextColumnFilter',
    floatingFilterComponentParams: {suppressFilterButton: true},
    minWidth: 100,
    flex: 1,
    sortable: true,
    resizable: true,
    suppressCsvExport: true,
    floatingFilter: true
  };

  cashDoc;
  gridApi;
  rowData: [];

  columnsDefs : any = [];

  ccyCode;
  total: number = 0;
  tax: number = 0;

  constructor() { }

  ngOnInit() {
    this.subs.sink = this.cashDoc$.subscribe(resolve =>{
      this.cashDoc = resolve;
      this.ccyCode = resolve.bl_fi_cash_document_hdr.doc_ccy;
      resolve.bl_fi_cash_document_lines.filter(l=>l.status==='ACTIVE').forEach(item => {
        this.total += <number>item.amount;
      })
    })

    if( this.cashDoc.bl_fi_cash_document_hdr.server_doc_type==='INTERNAL_CASH_TRANSFER'){
      this.columnsDefs.push({
        headerName: 'From Cashbook',
        field: 'cashbook_code',
        cellStyle: () => ({ 'text-align': 'left' }),
        valueGetter: (params) =>
            ['Transfer_From_Cashbook', 'Transfer_Charges'].includes(params.data.property_json.transferLineType) ?
            params.data.cashbook_code :
            null
      },
      {
          headerName: 'To Cashbook',
          field: 'cashbook_code',
          cellStyle: () => ({ 'text-align': 'left' }),
          valueGetter: (params) =>
              params.data.property_json.transferLineType === 'Transfer_To_Cashbook' ?
              params.data.cashbook_code :
              null
      })
    }else{
      this.columnsDefs.push({
        headerName: 'Cashbook',
        field: 'cashbook_code',
        cellStyle: () => ({ 'text-align': 'left' })
      })
    }
    this.columnsDefs.push({
      headerName: 'Created Date', field: 'created_date',
      cellStyle: () => ({ "text-align": "left" }),
      valueFormatter: (params) => moment(params.value).format("YYYY-MM-DD")
    },
    {
      headerName: 'Last Updated', field: 'updated_date',
      cellStyle: () => ({ "text-align": "left" }),
      valueFormatter: (params) => moment(params.value).format("YYYY-MM-DD")
    },

    {
      headerName: 'Status', field: 'status',
      cellStyle: () => ({ 'text-align': 'left' })

    },

    {
      headerName: 'Amount', field: 'amount',
      cellStyle: () => ({ "text-align": "left" })
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.gridApi.setRowData(this.cashDoc.bl_fi_cash_document_lines);
    console.log(this.rowData);
    this.gridApi.sizeColumnsToFit();
  }

  ngOnDestroy() {
    this.subs.unsubscribe;
  }

}
